export default __webpack_public_path__ + "static/media/undraw_back_to_school_inwc_(1).5ab4d834.svg";